import * as util from '../util/util'

import * as ws_base from '../ws/ws_base'


const DOMINIO = "itens";


export async function novoItem(item){

	let retorno = await ws_base.post(DOMINIO, "novo", item);

    console.log('dados retorno: '+JSON.stringify(retorno));

	if(retorno== null || retorno.id ==null)
		return {"id": null, "mensagem": ws_base.MENSAGEM_ERRO_GENERICA};

	return {"id": retorno.id, "mensagem":null};
}


export async function buscarItens(id_usuario, termos, situacao, situacaoAnuncio, index){

	return await ws_base.post(DOMINIO, "obter", {"id_usuario": id_usuario, 
													"termos": termos, 
														"situacao": situacao,
															"situacao_anuncio": situacaoAnuncio,
																"index": index});
}


export async function remover(id_item){

	return await ws_base.get(DOMINIO, "remover", {"id_item": id_item});
}


export async function buscarItem(id){

	return util.primeiroOuNada(await ws_base.get(DOMINIO, "obter", {"id": id}));
}


export async function alterarItem(item){
	
	return await ws_base.post(DOMINIO, "alterar", item);
}


export async function anunciar(id_item){
	
	return await ws_base.post(DOMINIO, "anunciar", {"id_item": id_item});
}


export async function buscarOfertas(id_usuario){

	return await ws_base.get(DOMINIO, "obter_ofertas", {"id_usuario": id_usuario});
}